<!-- TABLE -->
<div style="overflow: scroll">
  <mat-table [dataSource]="data" matSort matSortActive="patientName" matSortDirection="asc" matSortDisableClear multiTemplateDataRows>
    <!-- Name Column -->
    <ng-container matColumnDef="lastname">
      <mat-header-cell *matHeaderCellDef>
        {{ "model.patient.name" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <mat-icon class="toggle-button" [class.toggle-button-expanded]="isExpanded(row)">keyboard_arrow_down</mat-icon>
        {{ row.name }}</mat-cell
      >
    </ng-container>

    <!-- Firstname Column -->
    <ng-container matColumnDef="firstname">
      <mat-header-cell *matHeaderCellDef>
        {{ "model.patient.firstname" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.firstname }}</mat-cell>
    </ng-container>

    <!-- SSIN Column -->
    <ng-container matColumnDef="ssin">
      <mat-header-cell *matHeaderCellDef>
        {{ "forms.SSIN" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.ssin }}</mat-cell>
    </ng-container>

    <!-- Start Date -->
    <ng-container matColumnDef="startDate">
      <mat-header-cell *matHeaderCellDef>
        {{ "table.primoPrescriptionStart" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row | billingFirstPeriodStart | safeDate }}</mat-cell>
    </ng-container>

    <!-- End Date -->
    <ng-container matColumnDef="endDate">
      <mat-header-cell *matHeaderCellDef>
        {{ "table.end" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row | billingLastPeriodEnd | safeDate }}</mat-cell>
    </ng-container>

    <!-- Status -->
    <ng-container matColumnDef="status">
      <mat-header-cell *matHeaderCellDef>
        {{ "table.status" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="status-box" [ngClass]="billingStatusClasses[row | billingLastStatus]">
          {{ "billing.status." + (row | billingLastStatus) | translate }}
        </span>
      </mat-cell>
    </ng-container>

    <!-- internal id Column -->
    <ng-container matColumnDef="internalId">
      <mat-header-cell *matHeaderCellDef>
        {{ "table.internalId" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.internalId }}</mat-cell>
    </ng-container>

    <!-- pseudoname Column -->
    <ng-container matColumnDef="pseudoname">
      <mat-header-cell *matHeaderCellDef>
        {{ "forms.pseudoname" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.pseudoname }}</mat-cell>
    </ng-container>

    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
    <ng-container matColumnDef="expandedDetail" style="width: 100%">
      <mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length">
        <div style="width: 100%">
          <!-- TABLE -->
          <div style="overflow: scroll">
            <mat-table [dataSource]="row.chargeItems">
              <!-- Checkbox Column -->
              <ng-container matColumnDef="select">
                <mat-header-cell *matHeaderCellDef>
                  <mat-checkbox #masterCheckbox class="ml-15" (change)="$event ? masterToggle() : null"> </mat-checkbox>
                </mat-header-cell>
                <mat-cell *matCellDef="let subRow">
                  <mat-checkbox
                    class="ml-15"
                    (click)="$event.stopPropagation()"
                    (change)="$event ? selection.toggle(subRow) : null"
                    [checked]="selection.isSelected(subRow)"
                  >
                  </mat-checkbox>
                </mat-cell>
              </ng-container>

              <!-- Start Date -->
              <ng-container matColumnDef="startDate">
                <mat-header-cell *matHeaderCellDef>
                  {{ "table.periodStart" | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let subRow">{{ subRow.start | safeDate }}</mat-cell>
              </ng-container>

              <!-- End Date -->
              <ng-container matColumnDef="endDate">
                <mat-header-cell *matHeaderCellDef>
                  {{ "table.periodEnd" | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let subRow">{{ subRow.end | safeDate }}</mat-cell>
              </ng-container>

              <!-- Identification -->
              <ng-container matColumnDef="identification">
                <mat-header-cell *matHeaderCellDef>
                  {{ "table.identification" | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let subRow">{{ subRow.identification }}</mat-cell>
              </ng-container>

              <!-- renew -->
              <ng-container matColumnDef="renew">
                <mat-header-cell *matHeaderCellDef>
                  {{ "table.renew" | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let subRow">{{ (subRow.renew ? "common.yes" : "common.no") | translate }}</mat-cell>
              </ng-container>

              <!-- Adherence -->
              <ng-container matColumnDef="adherence">
                <mat-header-cell *matHeaderCellDef>
                  {{ "table.adherence" | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let subRow">{{ subRow.adherence * 100 }}%</mat-cell>
              </ng-container>

              <!-- Code -->
              <ng-container matColumnDef="code">
                <mat-header-cell *matHeaderCellDef>
                  {{ "table.code" | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let subRow">{{ subRow.code }}</mat-cell>
              </ng-container>

              <!-- Amount -->
              <ng-container matColumnDef="amount">
                <mat-header-cell *matHeaderCellDef>
                  {{ "table.amount" | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let subRow">{{ subRow.amount }}</mat-cell>
              </ng-container>

              <!-- Status -->
              <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef>
                  {{ "table.status" | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let subRow">
                  <span
                    class="status-box"
                    [ngClass]="billingStatusClasses[subRow.status]"
                    [matMenuTriggerFor]="(subRow.status | availableStatusTransitions).length > 0 ? statusMenu : undefined"
                  >
                    {{ "billing.status." + subRow.status | translate
                    }}<ng-container *ngIf="(subRow.status | availableStatusTransitions).length > 0">
                      &nbsp;<mat-icon class="fa-icon" fontSet="fas" fontIcon="fa-caret-down"></mat-icon
                    ></ng-container>
                  </span>

                  <mat-menu #statusMenu="matMenu">
                    <button
                      mat-menu-item
                      *ngFor="let status of subRow.status | availableStatusTransitions"
                      (click)="onUpdateStatus(subRow.identification, status)"
                    >
                      {{ "billing.status." + status | translate }}
                    </button>
                  </mat-menu>
                </mat-cell>
              </ng-container>

              <!-- type -->
              <ng-container matColumnDef="type">
                <mat-header-cell *matHeaderCellDef>
                  {{ "table.type" | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let subRow">{{ "forms.prescription.type." + subRow.type | translate }}</mat-cell>
              </ng-container>

              <!-- Actions -->
              <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef>{{ "table.action" | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let subRow">
                  <button mat-icon-button>
                    <mat-icon
                      class="fa-icon"
                      fontSet="fas"
                      fontIcon="fa-paper-plane"
                      (click)="$event.stopPropagation(); onSend(subRow.identification)"
                    ></mat-icon>
                  </button>
                  <button mat-icon-button *ngIf="('dashboard/exportChargeItem' | isAuthorized | async) === true">
                    <mat-icon
                      class="fa-icon"
                      fontSet="fas"
                      fontIcon="fa-download"
                      (click)="$event.stopPropagation(); download(subRow.identification)"
                    ></mat-icon>
                  </button>
                  <button mat-icon-button>
                    <mat-icon
                      class="fa-icon"
                      fontSet="fas"
                      fontIcon="fa-comments"
                      (click)="$event.stopPropagation(); showNotes(subRow)"
                    ></mat-icon>
                  </button>
                </mat-cell>
              </ng-container>

              <!-- Header & Rows -->
              <mat-header-row *matHeaderRowDef="chargeItemDisplayedColumns"></mat-header-row>
              <mat-row *matRowDef="let subRow; columns: chargeItemDisplayedColumns"></mat-row>
            </mat-table>
          </div>
        </div>
      </mat-cell>
    </ng-container>
    <!-- Header & Rows -->
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns" (click)="toggle(row)" class="element-row"></mat-row>
    <mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row" [class.detail-row-expanded]="isExpanded(row)"></mat-row>
  </mat-table>
</div>
